<div class="modal-header">
    <h5 class="modal-title">Associated Knox Events</h5>
    <button 
        type="button" 
        class="close" 
        aria-label="Close" 
        (click)="closeModal()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    @if (knoxEvents?.length > 0) { <s2-shared-knox-events [knoxEvents]="knoxEvents"></s2-shared-knox-events> }
</div>

<div class="modal-footer">
    <button 
        type='button' 
        class="btn btn-cancel btn-lg" 
        (click)="closeModal()"
    >Cancel</button>
</div>